import React from 'react';
import { motion } from 'framer-motion';

const SectionWrapper = ({ children, id, className = "", background = "transparent" }) => {
  return (
    <section 
      id={id} 
      className={`py-20 md:py-28 px-6 md:px-12 lg:px-24 w-full overflow-hidden ${className}`}
      style={{ background }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="max-w-7xl mx-auto"
      >
        {children}
      </motion.div>
    </section>
  );
};

export default SectionWrapper;